import React from 'react';

export const CornerFlourish = ({ className, accentColor = "currentColor" }) => (
  <svg viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path d="M10 90V10H90" stroke="currentColor" strokeWidth="0.8" />
    <path d="M20 80V20H80" stroke="currentColor" strokeWidth="0.3" opacity="0.4" />
    <path d="M10 10L40 40" stroke="currentColor" strokeWidth="0.5" />
    <circle cx="10" cy="10" r="2.5" fill={accentColor} />
    <circle cx="90" cy="10" r="1.5" fill="currentColor" opacity="0.5" />
    <circle cx="10" cy="90" r="1.5" fill="currentColor" opacity="0.5" />
  </svg>
);

export const FloralDivider = ({ className }) => (
  <div className={`flex items-center justify-center gap-3 ${className}`}>
    <div className="h-[0.5px] w-12 bg-estate-gold/40"></div>
    <div className="flex gap-2">
      <span className="w-1.5 h-1.5 rounded-full bg-floral-plum"></span>
      <span className="w-1.5 h-1.5 rounded-full bg-floral-coral"></span>
      <span className="w-1.5 h-1.5 rounded-full bg-floral-marigold"></span>
    </div>
    <div className="h-[0.5px] w-12 bg-estate-gold/40"></div>
  </div>
);

export const SectionFlourish = ({ className, color = "currentColor" }) => (
  <svg viewBox="0 0 100 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path d="M0 10H35M65 10H100" stroke="currentColor" strokeWidth="0.5" opacity="0.4" />
    <path d="M42 10L50 2L58 10L50 18L42 10Z" fill={color} />
    <circle cx="38" cy="10" r="1" fill="#D99A2B" />
    <circle cx="62" cy="10" r="1" fill="#E8A06E" />
  </svg>
);